export const environment = {
    production: false,
    urlHeader : 'https://menu.iconstruye.cl:4201/',
    urlApiMenuBff : 'https://qas-asteric-menu-bff.iconstruye.cl/',
    urlApiSSO: 'https://qa-api-login.azurewebsites.net/',
    domainCookie: 'iconstruye.cl',
    domainCookie2: 'agilice.cl',
    idGUIDSitioSeguridad: '67b7a78aa288dc1ea1f3f5f0',
    urlSso:'loginpp',
    idAplicacion:'69705772dd1451ad3c4722d5',
    idCambioEmpresa: '680ac36ca3b14205164b604a',
    urlBannerTransversal: {
        1: 'https://qa-web-banner-ic-transversal.iconstruye.cl/main.js',
        2: 'https://qa-web-banner-ic-transversal.agilice.cl/main.js',
        3: 'https://qa-web-banner-ic-transversal-redmat.iconstruye.cl/main.js'
    },
    bannerTransversalEnabled: true
};

